import HttpClienteSeguroCore from '../../Servicios/HttpClienteSeguroCore';
import RutasComponente from '../../Configuracion/RutaComponentes';
import SetModulos from '../../Configuracion/SetModulos/SetModulos'
import Enumerable from 'linq';

import { LlavesEndPointModulos } from "../../Configuracion/Llaves/RepositorioConfig";

export const AutorizacionUsuario = (compania, modulo, usuario, idioma, dispatch) => {
    try {
        // se toma todo el bloque de rutas y se procesa para que tenga la estructura de los menus 
        let autorizacionInicio = RutasComponente; // se extrae el archivo de navegacion inicial 

        // objeto que representa el bloque de autorizacion del usuario aplicado 
        let AutorizacionConfig = {
            Rutas: autorizacionInicio.Rutas,
            RutaLogin: autorizacionInicio.RutaLogin,
            RutaHome: autorizacionInicio.RutaHome,
            RutaNotFound: autorizacionInicio.RutaNotFound,
            RutaRecorevyPassword: autorizacionInicio.RutaRecorevyPassword,
            RutaRecorevyPasswordSussed: autorizacionInicio.RutaRecorevyPasswordSussed,
            RutaChangePassword: autorizacionInicio.RutaChangePassword,
            Modulo: autorizacionInicio.Modulo
        };

        // se extre la informacion de la autorizacion que tiene el usuario dentro de la base de datos 
        // debe retornar un ienumerable con la siguiente estructura 
        /*
              path : "/Instructor/NuevoInstructor",
              opt:"NuevoInstructor",
              menu:"Instructores",
              descripcion:"Nuevo Instructor",
              imgClass: "person_add",
              disabled : false
        */
        ExtraeBloqueSeguridadApi(compania, usuario, modulo, idioma).then(response => {
            if (response.status === 200) {
                // se realiza todo el procesamiento 
                // se compara el bloque de seguridad completo inicial que esta bloqueado 
                // contra el bloque de seguridad del usuario desde el api 

                //let RutasUsuariApi = response.data;
                let autUsuarioApi = response.data;
                
                let RutasAutorizadas = Enumerable.from(AutorizacionConfig.Rutas)
                    .groupJoin(Enumerable.from(autUsuarioApi),
                        config => config.opt,
                        api => api.opt,
                        (left, right) => ({ ...left, right }))
                    .selectMany(m => m.right.defaultIfEmpty(),
                        (left, right) => ({ ...left, ...right }))
                    .where(x => x.opt === 'Inicio' || x.id !== '00000000-0000-0000-0000-000000000000')
                    .toArray();

                // Se realiza el proceso de actualizacion del reducer de autorizacion con los datos que se extraen del api 
                dispatch({
                    type: "AUTORIZACION",
                    autorizacion: {
                        Rutas: RutasAutorizadas,
                        RutaLogin: AutorizacionConfig.RutaLogin,
                        RutaHome: AutorizacionConfig.RutaHome,
                        RutaNotFound: AutorizacionConfig.RutaNotFound,
                        RutaRecorevyPassword: AutorizacionConfig.RutaRecorevyPassword,
                        RutaRecorevyPasswordSussed: AutorizacionConfig.RutaRecorevyPasswordSussed,
                        RutaChangePassword: AutorizacionConfig.RutaChangePassword,
                        Modulo: AutorizacionConfig.Modulo
                    }
                });


                // Posterior a extraer el bloque de autorizacion de opciones se extrae la informacion de los modulos a los que tiene acceso 
                ExtraeBloqueSeguridadModulosApi(compania, usuario, idioma).then(response => {
                    if (response.status === 200) {
                        // se capturan los modulos del usuario 
                        let modulosUsuario = Enumerable.from(response.data)
                            .select(modUsuario => ({
                                IdModuloDB: modUsuario.idModulo,
                                ModuloDB: modUsuario.modulo,
                                TituloDB: modUsuario.titulo,
                                SubmoduloDB: modUsuario.submodulo,
                                UrlModuloDB: modUsuario.urlModulo,
                                LeyendaDB: modUsuario.leyenda,
                                FavoritesDB: modUsuario.favorites,
                                IconoDB: modUsuario.icono,
                                Referencia: modUsuario.referencia,
                                ModuloExterno: modUsuario.moduloExterno
                            })).toArray();

                        // Modulos configurados en el config                                  
                        let modulosConfig = Enumerable.from(SetModulos.Modulos)
                            .select(modConf => ({
                                ModuloConf: modConf.Modulo,
                                ImagenConf: modConf.Imagen,
                            })).toArray();

                        console.log(modulosUsuario);

                        const externals = Enumerable.from(modulosUsuario).where(x => x.ModuloExterno === true || x.TituloDB === 'CLASS Store').groupBy(
                            x => x.TituloDB,
                            TituloDB => TituloDB,
                            (key, items) => ({ key, items: items.toArray() }
                            )).toArray();

                        // Se realiza el dispatch para actualizar el reducer de los modulos del usuario
                        dispatch({
                            type: "MODULOS_EXTERNAL_AUTORIZACION",
                            autorizacionModExternal: {
                                Modulos: externals
                            }
                        });

                        console.log('stern', externals);

                        // Resultado de los modulos autorizados 
                        let modulosAutorizados = Enumerable.from(Enumerable.from(modulosUsuario)
                            .join(
                                modulosConfig,
                                pk => pk.ModuloDB,
                                fk => fk.ModuloConf,
                                (left, right) => ({ ...left, ...right })
                            )
                            .toArray())
                            .select(ModU => ({
                                IdModulo: ModU.IdModuloDB,
                                Modulo: ModU.ModuloDB,
                                Titulo: ModU.TituloDB,
                                Submodulo: ModU.SubmoduloDB,
                                UrlModulo: ModU.UrlModuloDB,
                                Leyenda: ModU.LeyendaDB,
                                Imagen: ModU.ImagenConf,
                                Acceso: true,
                                Favorites: ModU.FavoritesDB,
                                Icono: ModU.IconoDB,
                                Referencia: ModU.Referencia,
                                ModuloExterno: ModU.ModuloExterno
                            })).toArray();

                        // Se realiza el dispatch para actualizar el reducer de los modulos del usuario
                        dispatch({
                            type: "MODULOS_AUTORIZACION",
                            autorizacionMod: {
                                Modulos: modulosAutorizados
                            }
                        });

                    }
                });

            }
        });
    } catch (e) {

    }
};


// se encarga de extraer la informacion como tal la el bloque de informacion
const ExtraeBloqueSeguridadApi = (Compania, Usuario, Modulo, Idioma) => {

    let parametros = {
        Compania: Compania,
        Modulo: Modulo,
        Usuario: Usuario,
        Idioma: Idioma
    }

    return new Promise((resolve, reject) => {
        HttpClienteSeguroCore.post("/Autorizacion/Autorizacion", parametros).then(response => {

            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    });
};


// se encarga de extraer la informacion como tal la el bloque de modulos del usuario 
const ExtraeBloqueSeguridadModulosApi = (Compania, Usuario, Idioma) => {

    let parametros = {
        Compania: Compania,
        Usuario: Usuario,
        Idioma: Idioma,
        UrlBase: LlavesEndPointModulos.UrlBaseModulos
    }

    return new Promise((resolve, reject) => {
        HttpClienteSeguroCore.post("/Autorizacion/AutorizacionModulos", parametros).then(response => {

            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    });
};


export default AutorizacionUsuario;